import { useEffect } from "react";
import { FileStore } from "../../store/fileUploadStore";

/**
 * Resets chat-related state when switching between chats.
 * Clears files, prompt, sets active chat, etc.
 * 
 * @param {string|undefined} chat_id - Current chat ID
 * @param {object} user - User object with uid
 * @param {object} stateSetters - Object containing state setter functions
 * @param {function} stateSetters.setFiles - Clear files array
 * @param {function} stateSetters.setNewFiles - Clear new files array
 * @param {function} stateSetters.setPrompt - Clear prompt text
 * @param {function} stateSetters.setActiveChat - Set active chat ID
 * @returns {void}
 */
export const useChatStateReset = (chat_id, user, stateSetters) => {
  const {
    setFiles,
    setNewFiles,
    setPrompt,
    setActiveChat,
  } = stateSetters;

  useEffect(() => {
    if (chat_id && user?.uid) {
      setFiles([]);
      setNewFiles([]);
      FileStore.getState().setFileLoading(false);
      setPrompt("");
      setActiveChat(chat_id);
    }
  }, [chat_id, user?.uid, setActiveChat, setFiles, setPrompt, setNewFiles]);
};
